module.exports = __webpack_public_path__ + "static/media/tag.53b345a8.svg";